import route from '../route';
import BIForm from '../form/form';

$(function () {

    if (route === 'auth.edit-pass') {
        let PasswordResetForm = new BIForm({
            form_id: `.editPasswordForm`
        });

        PasswordResetForm.addSubmitListener((response) => {
            
            if (response.success) {
                PasswordResetForm.turnFormLoadingOff();
                PasswordResetForm.form[0].reset();
                PasswordResetForm.showSuccess(response.message);

                setTimeout(() => {
                    window.location.href = '/auth/logout';
                }, 2000);
            }
        });
    }
});